import React from "react";
export default function GuestHeader(props: any) {
  return (
    <div className={"guest-header"}>
      {/* <SelectLanguageMobile dropdownId={"dropdown-guest-header-mobile"} /> */}
      {/* <div className="logo-block">{renderLogo()}</div> */}
    </div>
  );
}
